(() => {
  const variableName = '--current-dialog-top';
  /** @type {number | null} */
  let rafId = null;

  const getScrollTop = () => {
    const fixedBodyTop = Number.parseFloat(document.body?.style.top);

    if (document.body?.style.position === 'fixed' && fixedBodyTop < 0) {
      return Math.abs(fixedBodyTop);
    }

    return document.scrollingElement?.scrollTop ?? window.scrollY;
  };

  let wasScrolled = getScrollTop() > 0;

  const update = () => {
    if (!document.body) return;

    const scrollLocked = document.documentElement.hasAttribute('scroll-lock') || document.body.style.position === 'fixed';
    const scrollTop = getScrollTop();

    if (!scrollLocked || scrollTop > 0) {
      wasScrolled = scrollTop > 0;
    }

    const sourceVariable = wasScrolled ? '--header-height' : '--header-group-height';
    const value = getComputedStyle(document.body).getPropertyValue(sourceVariable).trim();

    document.body.style.setProperty(variableName, value || '0px');
  };

  const scheduleUpdate = () => {
    if (rafId !== null) return;

    rafId = requestAnimationFrame(() => {
      rafId = null;
      update();
    });
  };

  const init = () => {
    update();

    document.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    window.addEventListener('load', scheduleUpdate, { once: true });

    const headerGroup = document.querySelector('#header-group');
    if (headerGroup && 'ResizeObserver' in window) {
      new ResizeObserver(scheduleUpdate).observe(headerGroup);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
